module.exports = __webpack_public_path__ + "static/media/ticketCollection.9a696668.png";